import React from "react";
import PropTypes from "prop-types";
import Variant from "../../../../models/Variant";
import store from "../../../../state/store";
import isPortal from "../../../../common/helpers/isPortal";

function VariantLink({ variant }) {
  const { genomeId } = variant?.region?.chromosome;
  const { varsomeHost } = store.getState();
  const spec = variant?.spec;
  const variantId = variant?.id;
  const prettySpec = variant?.prettySpec;

  const link =
    spec && variant?.region?.chromosome?.id < 25
      ? `${varsomeHost}/variant/${genomeId}/${spec}`
      : `${varsomeHost}/variant/${genomeId}/${variantId}`;

  return spec || variantId ? (
    <a
      className="tw-font-bold tw-leading-loose tw-tracking-wider"
      href={link}
      target="_blank"
      data-tooltip={isPortal() ? "Open In VarSome" : "Open in a new page"}
      data-tooltip-class="genome-browser-small-tooltip"
    >
      {prettySpec || variantId || "See variant"}
    </a>
  ) : null;
}

VariantLink.propTypes = {
  variant: PropTypes.instanceOf(Variant).isRequired,
};

VariantLink.defaultProps = {};

export default VariantLink;
